import { useState } from "react";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "919876543210";

    const text = `
Hi, I want to contact you:

Name: ${form.firstName} ${form.lastName}
Email: ${form.email}
Phone: ${form.phone}
Message: ${form.message}
`;

    const encodedText = encodeURIComponent(text);

    window.open(`https://wa.me/${9182684479}?text=${encodedText}`, "_blank");
  };

  return (
    <section className="bg-gradient-to-b from-[#a78bfa] via-[#e6e0ff] to-white py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* FORM + MAP */}
        <div className="grid lg:grid-cols-2 gap-10">

          {/* FORM */}
          <div className="bg-white rounded-3xl p-8 shadow-sm">
            <h2 className="text-3xl font-bold mb-2">Contact Us</h2>
            <p className="text-gray-500 mb-6">
              Our friendly team would love to hear from you!
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">

              <div className="flex gap-4">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={handleChange}
                  required
                  className="w-full border rounded-full px-4 py-3"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={handleChange}
                  required
                  className="w-full border rounded-full px-4 py-3"
                />
              </div>

              <input
                type="email"
                name="email"
                placeholder="you@company.com"
                onChange={handleChange}
                required
                className="w-full border rounded-full px-4 py-3"
              />

              <input
                type="tel"
                name="phone"
                placeholder="+91 9876543210"
                onChange={handleChange}
                required
                className="w-full border rounded-full px-4 py-3"
              />

              <textarea
                name="message"
                placeholder="Enter Message"
                onChange={handleChange}
                required
                className="w-full border rounded-2xl px-4 py-3 h-32"
              />

              <button
                type="submit"
                className="w-full bg-black text-white py-3 rounded-full hover:opacity-90 transition"
              >
                Send Message
              </button>

            </form>
          </div>

          {/* MAP */}
          <div className="rounded-3xl overflow-hidden shadow-sm">
            <iframe
              title="Maxzen Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.3793976238157!2d78.39007467493721!3d17.48939338341532!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9100181b73e3%3A0xa53b5c4c96b5d5f1!2sMaxzen%20HR%20Services!5e0!3m2!1sen!2sin!4v1777461665700!5m2!1sen!2sin"
              className="w-full h-full min-h-[400px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>

        </div>

        {/* CONTACT CARDS */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">

          {/* EMAIL */}
          <div className="bg-white rounded-2xl p-12 shadow-sm hover:shadow-lg transition border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="bg-gradient-to-br from-purple-500 to-indigo-600 text-white p-3 rounded-xl shrink-0">
                <Mail className="w-5 h-5" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
                  Email
                </p>
                <a
                  href="mailto:info@maxzenhr.com"
                  className="font-semibold text-gray-800 hover:text-indigo-600"
                >
                  info@maxzenhr.com
                </a>
              </div>
            </div>
          </div>

            {/* ADDRESS */}


          <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition border border-gray-100">
            <div className="flex items-start gap-4">
              <div className="bg-gradient-to-br from-purple-500 to-indigo-600 text-white p-3 rounded-xl shrink-0">
                <MapPin className="w-5 h-5" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
                  Address
                </p>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Maxzen+HR+Services+Hyderabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-gray-800 hover:text-indigo-600"
                >
                  14th Floor, Manjeera Trinity Corporate, KPHB Phase 3, Hyderabad - 500072
                </a>
              </div>
            </div>
          </div>

          {/* PHONE */}
          <div className="bg-white rounded-2xl p-12 shadow-sm hover:shadow-lg transition border border-gray-100">
            <div className="flex items-start gap-8">
              <div className="bg-gradient-to-br from-purple-500 to-indigo-600 text-white p-3 rounded-xl shrink-0">
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-wide text-gray-400 mb-1">
                  Phone
                </p>
                <a
                  href="tel:8498989844"
                  className="font-semibold text-gray-800 hover:text-indigo-600"
                >
                  +91 84989 89844
                </a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}